/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {InitiateTransactionReversalRequest} from '@cash-web/protos/squareup/banklin/ledger_service.pb'
import {InitiateTransactionReversalResponse} from '@cash-web/protos/squareup/banklin/ledger_service.pb'


export const initiateTransactionReversal = (request: InitiateTransactionReversalRequest, options?: CashRequestOptions) => post<InitiateTransactionReversalRequest, InitiateTransactionReversalResponse>("/2.0/cash/initiate-transaction-reversal", request, {...options, rejectOnError: true })